import { Box, Button, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AppCarousel from "../../components/AppCarousel/AppCarousel";
import { ROUTE_PATH } from "../../helper/Constants";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useTranslation } from "react-i18next";
import { displayNo } from "../../helper/Number";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/slices/cartSlice";
import { getLocalStorage } from "../../helper/Storage";

const ProductDetails = () => {
  const [t] = useTranslation();

  const contacts = useSelector((state) => state.contacts.contacts);
  const incenses = useSelector((state) => state.incenses.items);
  const spices = useSelector((state) => state.spices.items);

  const [product, setProduct] = useState();
  const { id } = useParams();
  const { type } = useParams();
  const lan = getLocalStorage("userLanguage");
  const dispatch = useDispatch();

  const navigate = useNavigate();

  useEffect(() => {
    if (id && type) {
      if (type === ROUTE_PATH.INCENSES) {
        const products = incenses?.filter((p) => p.id === id);
        if (products && products[0]) {
          setProduct(products[0]);
        }
      } else {
        const products = spices?.filter((p) => p.id === id);
        if (products && products[0]) {
          setProduct(products[0]);
        }
      }
    }
  }, [id, type, incenses, spices]);

  const handelAddToCart = () => {
    dispatch(
      addToCart(
        {
          itemId: id,
          type,
          offerPrice: product.price.offerPrice,
          actualPrice: product.price.actualPrice,
          deliveryFee: contacts.deliveryFee,
        },
        "addToCart",
      ),
    );
    navigate("/" + ROUTE_PATH.CART);
  };

  return (
    <>
      {product && (
        <Box sx={{ padding: "25px" }}>
          <Grid container>
            <Grid size={{ lg: 4, md: 6, xs: 12 }}>
              <AppCarousel
                name="ProductDetails"
                list={product?.images}
                className={"product-details-img"}
              ></AppCarousel>
            </Grid>
            <Grid size={{ lg: 8, md: 6, xs: 12 }}>
              <Box sx={{ textAlign: "left", padding: "0 25px" }}>
                <Typography sx={{ fontSize: "25px" }}>
                  {product?.name.find((n) => n.key === lan).value}
                </Typography>
                <Typography sx={{ fontSize: "12px" }}>
                  {t("product.details.title")}
                </Typography>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "bold",
                      padding: "0 3px",
                      fontSize: "25px",
                    }}
                  >
                    ₹{displayNo(Number(product.price.offerPrice).toFixed(2))}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ textDecoration: "line-through", color: "#888888ff" }}
                  >
                    ₹{displayNo(Number(product.price.actualPrice).toFixed(2))}
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontWeight: "bold",
                      padding: "0 3px",
                      color: "#28d311ff",
                    }}
                  >
                    {displayNo(product.price.offer)}
                    {t("off")}
                  </Typography>
                </Box>
                <Typography>
                  {product?.description.find((n) => n.key === lan).value}
                </Typography>
                <ul>
                  {product?.details
                    ?.find((n) => n.key === lan)
                    .value?.split("\n ")
                    .map((del, index) => (
                      <li key={"del_" + index}>{del}</li>
                    ))}
                </ul>
                <Button variant="contained" onClick={handelAddToCart}>
                  <ShoppingCartIcon />
                  <Typography>{t("product.detail.addtocart")}</Typography>
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}
      {!product && <Box sx={{ padding: "10px" }}>Product Not Found</Box>}
    </>
  );
};

export default ProductDetails;
